import React, { useEffect, useContext, useState, useRef } from 'react'

import {
  Hidden,
  Drawer,
  Dialog
} from '@material-ui/core'


const MyModal = ({isOpen, onClose, maxWidth, children, overflow, background}) => {

  return (
    <>
      <Hidden smUp>
        <Drawer
          anchor='bottom'
          open={isOpen}
          onClose={onClose}
          sx={{
            //background:"transparent",
          }}
          PaperProps={{
            sx: {
              height: 'calc(100% - 70px)',
              width : 'calc(100% - 30px)',
              top: '55px',
              left : '15px',
              backgroundColor:background ? background : "background.default",
              overflow:overflow ? overflow : "auto",
            },
          }}
        >
          {children}
        </Drawer>
      </Hidden>


      <Hidden smDown>
        <Dialog
          fullWidth={true}
          maxWidth={maxWidth?maxWidth:"md"}
          open={isOpen}
          onClose={onClose}
          PaperProps={{
            sx : {
              borderRadius:"0px",
              border:"1px solid #E7E7E7",
              overflow:overflow ? overflow : "auto",
            }
          }}
        >
          {children}
        </Dialog>
      </Hidden>
    </>
  )
}


export default MyModal
